
<template>
    <div>
        <vs-table>
            <template #thead>
            <vs-tr>
                <vs-th style="width: 10%;">
                </vs-th>
                <vs-th style="width: 35%;">
                    Clave
                </vs-th>
                <vs-th style="width: 35%;">
                    Documento
                </vs-th>
                <vs-th style="width: 20%;">
                    Acciones
                </vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in documentos"
                :data="tr"
                style="border-bottom: 1px solid #CACFD2"
                v-if="tr.path"
            >
                <vs-td>
                    <p><strong>{{ tr.id }}</strong></p>
                </vs-td>
                <vs-td>
                    <p class="mb-0"><small>CLAVE</small></p>
                    <p><strong>{{ tr.clave }}</strong></p>
                    <p class="mb-0"><small>NOMBRE</small></p>
                    <p><strong>{{ tr.nombre }}</strong></p>
                </vs-td>
                <vs-td>
                    <!-- <p class="mb-0"><small><strong>DISEÑO PERSONALIZADO</strong></small></p>
                    <md-chip class="mb-3 fontMedium mini-chip" :class="getColorMetodo(tr.con_formato)">
                        <strong>
                            <span class="text-uppercase">{{ tr.con_formato }}</span>
                        </strong>
                    </md-chip>
                    <p class="mb-0"><small><strong>ENTREGA POR ALUMNO</strong></small></p>
                    <md-chip class="mb-3 fontMedium mini-chip" :class="getColorMetodo(tr.requiere_respuesta)">
                        <strong>
                            <span class="text-uppercase">{{ tr.requiere_respuesta }}</span>
                        </strong>
                    </md-chip> -->
                    <p class="mb-0"><small><strong>ARCHIVO EXTERNO</strong></small></p>
                    <md-chip class="mb-3 fontMedium mini-chip" :class="tr.path == null || tr.path == '' ? getColorMetodo('no') : getColorMetodo('si')">
                        <strong>
                            <span class="text-uppercase">{{ tr.path == null || tr.path == '' ? 'No' : 'Si' }}</span>
                        </strong>
                    </md-chip>
                </vs-td>
                <vs-td>
                    <vs-button
                        flat
                        @click="activeEditar =! activeEditar, selectedRow = tr"
                    >
                        <i class="fas fa-edit mr-2"></i> Editar
                    </vs-button>
                </vs-td>
            </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>

        </vs-table>
        <editar v-model="activeEditar" :instituciones="instituciones" :row="selectedRow" @refreshTable="getRefresh" :tipoModal="tipoModal"></editar>
    </div>
</template>
<script>
import editar from './modales/externo-editar.vue'
    export default {
        props: [
            'documentos',
            'instituciones',
        ],
        data:() => ({
            activeEditar: false,
            selectedRow: [],
            tipoModal: 'subir'
        }),
        components: {
            editar
        },
        methods:{
            getColorMetodo(diseno){
                if (diseno === 'no'){
                    return 'col-red'
                }
                if (diseno === 'si'){
                    return 'col-green'
                }
            },
            getRefresh(){
                this.$emit('refreshTable')
            }
        }
    }
</script>

<style scoped>
    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }
</style>

        